<template>
    <div>
        <div class="sunshine-container" :style="$vuetify.breakpoint.mdAndUp ? `max-width: 350px; height: 350px; margin: 0 auto;` : `max-width: 250px; height: 250px; margin: 0 auto;`">
            <img src="../assets/sun.png" class="sun" draggable="false" />
            <img src="../assets/cloud1.png" class="cloud cloud--1" draggable="false" />
            <img src="../assets/cloud2.png" class="cloud cloud--2" draggable="false" />
            <img src="../assets/cloud3.png" class="cloud cloud--3" draggable="false" />
        </div>
        <div class="headline text-center mb-2">{{ $t('Nicely done!') }}</div>
        <div class="body text-center grey--text" style="max-width: 290px; margin: 0 auto;">{{ $t('You\'ve finished all your tasks, take a second to recharge') }}</div>
    </div>
</template>

<script>
export default {
    name: "Sunshine"
};
</script>

<style lang="scss" scoped>
.sunshine-container {
    position: relative;
}

.sun {
    width: 90%;
    position: absolute;
    left: 5%;
    top: 5%;
    z-index: 2;
    animation: rotation 110s infinite linear;
}

.cloud {
    position: absolute;
}

.cloud--1 {
    right: 0;
    bottom: 23%;
    z-index: 2;
    width: 42%;
    animation: slideRightIntoPlace 6s cubic-bezier(0, 0.32, 0, 0.99);
}

.cloud--2 {
    z-index: 0;
    left: 0;
    top: 29%;
    width: 19%;
    animation: slideLeftIntoPlace 6s cubic-bezier(0, 0.32, 0, 0.99);
}

.cloud--3 {
    right: 0;
    top: 6%;
    width: 13%;
}

@keyframes slideRightIntoPlace {
    from {
        transform: translateX(-15px);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes slideLeftIntoPlace {
    from {
        transform: translateX(8px);
    }
    to {
        transform: translateX(0);
    }
}
</style>
